"use strict";
/* eslint-disable @typescript-eslint/no-unused-vars */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var ClientBridge_1 = require("./ClientBridge");
var HostType_1 = require("../interfaces/HostType");
var IC3ClientV1Adapter_1 = require("./IC3ClientV1Adapter");
var FramelessBridge = /** @class */ (function (_super) {
    __extends(FramelessBridge, _super);
    function FramelessBridge(protocolType) {
        var _this = _super.call(this, protocolType) || this;
        _this.hostType = HostType_1.default.Page;
        _this.protocolAdapter = new IC3ClientV1Adapter_1.default("", _this.hostType);
        return _this;
    }
    FramelessBridge.prototype.setup = function (setupParams) {
        return Promise.resolve();
    };
    FramelessBridge.prototype.update = function (sessionInfo) {
        return Promise.resolve();
    };
    FramelessBridge.prototype.onRegisterOnNewMessage = function (conversation) {
        return Promise.resolve();
    };
    FramelessBridge.prototype.onRegisterOnThreadUpdate = function (conversation) {
        return Promise.resolve();
    };
    FramelessBridge.prototype.initialize = function (sessionInfo) {
        return this.protocolAdapter.initialize(sessionInfo);
    };
    FramelessBridge.prototype.dispose = function () {
        return this.protocolAdapter.dispose();
    };
    FramelessBridge.prototype.sendMessage = function (conversation, message) {
        return this.protocolAdapter.sendMessage(conversation, message);
    };
    FramelessBridge.prototype.sendFileMessage = function (conversation, fileMetadata, message) {
        return this.protocolAdapter.sendFileMessage(conversation, fileMetadata, message);
    };
    FramelessBridge.prototype.getMessages = function (conversation) {
        return this.protocolAdapter.getMessages(conversation);
    };
    FramelessBridge.prototype.disconnectFromConversation = function (conversation) {
        return this.protocolAdapter.disconnectFromConversation(conversation);
    };
    FramelessBridge.prototype.onJoinConversation = function (conversationId, sendHeartBeat) {
        return this.protocolAdapter.joinConversation(conversationId, sendHeartBeat);
    };
    FramelessBridge.prototype.sendFileData = function (conversation, fileInfo, fileSharingProtocolType) {
        return this.protocolAdapter.sendFileData(conversation, fileInfo, fileSharingProtocolType);
    };
    FramelessBridge.prototype.downloadFileData = function (conversation, fileMetadata) {
        return this.protocolAdapter.downloadFileData(conversation, fileMetadata);
    };
    FramelessBridge.prototype.getFileStatus = function (conversation, fileMetadata) {
        return this.protocolAdapter.getFileStatus(conversation, fileMetadata);
    };
    FramelessBridge.prototype.indicateTypingStatus = function (conversation, typingStatus, optionalProperties) {
        return this.protocolAdapter.indicateTypingStatus(conversation, typingStatus, optionalProperties);
    };
    FramelessBridge.prototype.sendMessageToBot = function (conversation, botId, botMessage) {
        return this.protocolAdapter.sendMessageToBot(conversation, botId, botMessage);
    };
    FramelessBridge.prototype.getMembers = function (conversation) {
        return this.protocolAdapter.getMembers(conversation);
    };
    FramelessBridge.prototype.registerOnNewMessage = function (conversation, callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.protocolAdapter.registerOnNewMessage(conversation, callback);
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    FramelessBridge.prototype.registerOnThreadUpdate = function (conversation, callback) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.protocolAdapter.registerOnThreadUpdate(conversation, callback);
                return [2 /*return*/, Promise.resolve()];
            });
        });
    };
    FramelessBridge.prototype.setDebug = function (flag) {
        if (flag === void 0) { flag = false; }
        this.protocolAdapter.setDebug(flag);
    };
    return FramelessBridge;
}(ClientBridge_1.default));
exports.default = FramelessBridge;
//# sourceMappingURL=FramelessBridge.js.map